import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { paddingV } from '../constants';
import NavIcon from './svg/NavIcon';


const SmallNavbar = () => {
  const color = useSelector(state => state.colorSlice.value);
  return (
    <Links>
      <SNavLink to="/" color={color}>
        <NavIcon home />
      </SNavLink>
      <SNavLink to="/about" color={color}>
        <NavIcon user />
      </SNavLink>
      <SNavLink to="/work" color={color}>
        <NavIcon recent />
      </SNavLink>
      <SNavLink to="/contact" color={color}>
        <NavIcon phone />
      </SNavLink>
    </Links>
  )
}

export default SmallNavbar;

const Links = styled.div`
  display: none;
  justify-content: space-between;
  align-items: center;
  column-gap: 1rem;
  @media screen and (max-width: 500px) {
    position: fixed;
    display: flex;
    bottom: ${paddingV};
    left: 50%;
    transform: translateX(-50%);
  }
`;
const SNavLink = styled(NavLink)`
  font-size: 1rem;
  position: relative;
  z-index: 1;
  svg {
    width: 1.7rem;
    height: 1.6rem;
    stroke-width: 1rem;
    &:nth-of-type(3), &:nth-of-type(4) {
      fill: red;
    }
  }
  &.active svg {
    fill: #fff;
  }
  &::after {
    content: '';
    position: absolute;
    display: block;
    width: 0;
    height: 7px;
    border-radius: 1rem;
    background-color: ${props => props.color};
    left: 50%;
    transform: translateX(-50%);
  }
  &.active::after {
    width: 7px;
  }

`;